import React from 'react'
import { BaseView } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'
import { responsiveAdapter } from '@/utils'

interface RadioButtonProps {
  selected: boolean
  size?: number
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  selected,
  size = 24,
}) => {
  const theme = useTheme()
  const responsiveSize = responsiveAdapter(size)
  const innerSize = responsiveSize * 0.5

  return (
    <BaseView
      center
      style={{
        width: `${responsiveSize}px`,
        height: `${responsiveSize}px`,
        borderRadius: `${responsiveSize / 2}px`,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: theme.colors.background.radioButton,
        transition: 'all 0.2s ease',
        position: 'relative',
      }}
    >
      {selected && (
        <BaseView
          style={{
            width: `${innerSize}px`,
            height: `${innerSize}px`,
            borderRadius: `${innerSize / 2}px`,
            backgroundColor: theme.colors.background.radioButton,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      )}
    </BaseView>
  )
}
